var map = {
	"./img/area-bg.png": "Puks",
	"./img/img-1.png": "NprT",
	"./img/img-10.png": "6gY8",
	"./img/img-2.png": "tmPC",
	"./img/img-3.png": "4LLr",
	"./img/img-4.png": "tQf7",
	"./img/img-5.png": "v4Bt",
	"./img/img-6.png": "9reR",
	"./img/img-7.png": "UEyc",
	"./img/img-8.png": "BK2i",
	"./img/img-9.png": "fUJh",
	"./img/top-bg.png": "ZzwB"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "YOLc";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Home ^.*\.png$
// module id = YOLc
// module chunks = 1